import mediaData from "@/i18n/json/media/data.json"
import {articleContainer, articleContent, articleImg, articleItem, articleSource, articleTitle} from "./style";
import {useTranslation, Trans} from "react-i18next";

const ArticleItems = () => {
    const articles = [...mediaData.articles];
    const {t} = useTranslation();
    return <div className={articleContainer}>
        {articles.map((item, index) => {
            return <a href={item.url} target={"_blank"} key={index}>
                <div className={articleItem}>
                    <img className={articleImg} src={`/assets/images/media/articles/${item.img}`}
                         alt={t(`media.article-section.articles.${index}.img.alt`)}
                         title={t(`media.article-section.articles.${index}.img.alt`)}/>
                    <div>
                        <p className={articleTitle}>
                            <Trans components={{sup: <sup/>}}>{`media.article-section.articles.${index}.title`}</Trans>
                        </p>
                        <p className={articleSource}>{item.source}</p>
                        <p className={articleContent}>{t(`media.article-section.articles.${index}.date`)}</p>
                    </div>
                </div>
            </a>
        })}
    </div>
}

export default ArticleItems